import React from "react";
import * as Icons from "lucide-react";
import { Reveal, Overline } from "../components/site/Reveal";
import { INDUSTRIES } from "../data/content";

export const Industries = () => (
  <section id="industries" className="relative bg-white py-24 sm:py-32" data-testid="industries-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="max-w-2xl">
        <Reveal><Overline>Industries We Serve</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-serif text-4xl font-light leading-tight text-charcoal sm:text-5xl">
            Deep expertise across <span className="text-gradient-emerald">complex sectors</span>.
          </h2>
        </Reveal>
      </div>

      <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {INDUSTRIES.map((ind, i) => {
          const Icon = Icons[ind.icon] || Icons.Building2;
          return (
            <Reveal key={ind.title} delay={i * 0.07}>
              <div data-testid={`industry-card-${i}`}
                className="group relative h-full overflow-hidden rounded-[1.5rem] border border-black/5 bg-bg-light p-8 transition-[transform,border-color] duration-500 hover:-translate-y-1.5 hover:border-gold/40">
                <div className="flex items-center gap-4">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-white text-emerald-base shadow-sm transition-colors duration-500 group-hover:bg-emerald-base group-hover:text-gold-light">
                    <Icon size={22} />
                  </div>
                  <h3 className="font-serif text-2xl text-charcoal">{ind.title}</h3>
                </div>
                <p className="mt-5 text-sm leading-relaxed text-charcoal/65">{ind.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
